import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DateCountDownDirective } from '../../../../directives/date-counter-down.directive';
import { InputsModule } from '../../inputs.module';
import { IVerificationCodeInput } from '../../interface';
import { DateService } from '../../services/date.service';
import { BaseInputComponent } from '../base-input/base-input.component';
import { buildForm } from './form';

@Component({
    selector: 'app-verification-code',
    templateUrl: './verification-code.component.html',
    styleUrl: './verification-code.component.scss',
    imports: [InputsModule, FormsModule, DateCountDownDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerificationCodeComponent extends BaseInputComponent<IVerificationCodeInput> {
  @Output() onSubmit = new EventEmitter<string>();
  @Output() onResendCode = new EventEmitter<string>();

  @ViewChildren('box1Input, box2Input, box3Input, box4Input')
  inputs!: QueryList<ElementRef>;
  form = buildForm();
  isShowErrors = false;
  timerTo = new Date();
  allowResend = false;
  constructor(private dateService: DateService) {
    super();
  }
  ngOnInit() {
    this.setResendCodeTimer();
  }
  onNgAfterViewInit() {
    this.setFocusOnFirstInput();
  }

  setFocusOnFirstInput() {
    const firstInput = this.inputs.first;
    if (firstInput) {
      firstInput.nativeElement.focus();
    }
  }

  // onInput method is triggered whenever the user types.
  onInput(event: any, index: number): void {
    const input = event.target;
    const value = input.value as string;

    // Ensure only one character is entered
    if (index == 0 && value.length >= 4) {
      const c1Text = value.slice(value.length - 4);
      this.form.patchValue({
        c1: c1Text[0],
        c2: c1Text[1],
        c3: c1Text[2],
        c4: c1Text[3],
      });
    } else if (value.length > 1) {
      this.form
        .get(`c${index + 1}`)
        ?.setValue(value[value.length - 1] as never);
    }

    this.updateValue((index == 0 && value.length >= 4) || index == 3);

    // Move to the next input if the value is not empty and index is less than 3
    if (index < 3) {
      const nextInput = this.inputs.toArray()[index + 1];
      if (nextInput) {
        nextInput.nativeElement.focus();
      }
    }
  }
  //Checks if the Backspace key was pressed and if the current input box is empty.
  //If both conditions are met, it moves the focus to the previous input box (if it exists).
  onKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      const currentInput = this.inputs.toArray()[index];
      if (!currentInput.nativeElement.value) {
        // Reset current box value to null
        this.form.get(`c${index + 1}`)?.reset();

        // Move focus to the previous input if it exists
        const prevInput = this.inputs.toArray()[index - 1];
        if (prevInput) {
          setTimeout(() => {
            prevInput.nativeElement.focus();
          }, 0);
        }
      }
    }
  }
  updateValue(isAutoSubmit = false) {
    const value = `${this.form.value.c1 || ''}${this.form.value.c2 || ''}${this.form.value.c3 || ''}${this.form.value.c4 || ''}`;
    this.form.controls.fullCode?.setValue(value);
    if (this.form.valid && isAutoSubmit) this.submit();
  }

  submit() {
    if (this.form.invalid) {
      this.isShowErrors = true;
      return;
    }
    this.isShowErrors = false;

    this.onSubmit.emit(this.form.controls.fullCode.value);
  }

  resendCode() {
    this.onResendCode.emit();
    this.setResendCodeTimer();
  }

  setResendCodeTimer() {
    this.timerTo = this.dateService.increaseMinutes(2);
    this.allowResend = false;
  }
}
